/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("brcheckModule", []).
controller("brcheckCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'item', "$document", "$timeout", "burstNewsRuleService", "modalDialog", function($scope, $modalInstance, trsHttpService, item, $document, $timeout, burstNewsRuleService, modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
        };
        $scope.data = {
            items: item,
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        brcheckData();
    }
    /**
     * [deleteData description] 删除数据请求
     */
    function brcheckData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'getrule',
            'id': $scope.data.items.id,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.checkCont = data;
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.brcancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [del description] 删除弹窗
     * @return {[type]} [description]
     */
    $scope.brdel = function(id) {
        modalDialog.confirmModal("删除提示", "是否确定删除？", function() {
            var params = {
                "typeid": 'screen',
                "serviceid": 'zjsentimentrulemgr',
                "modelid": 'deleterule',
                'id': id,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                $modalInstance.close(true);
            });
        });
    };
    /**
     * [editrule description] 编辑弹窗
     * @return {[type]} [description]
     */
    $scope.breditrule = function(id) {
        burstNewsRuleService.breditrule(id, item.type).then(function(data) {
            if (data == true) {
                $modalInstance.close(true);
            }
        });
    };

}]);